import { jsx as _jsx } from "react/jsx-runtime";
import { Helmet } from './helmet';
import { useBootstrapData } from '../core/bootstrap-data/bootstrap-data-context';
export function DefaultMetaTags() {
    const { data: { default_meta_tags }, } = useBootstrapData();
    return _jsx(Helmet, { tags: default_meta_tags });
}
